import { DatePickerValue, F0DatePicker } from '@factorialco/f0-react'
import { Field } from 'factorial-form'
import type moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'

export interface Props {
  date: Field
  hideLabel?: boolean
  minDateFromLeave?: moment.Moment
  maxDateFromLeave?: moment.Moment | null
}

const SingleDatePicker = ({
  date,
  hideLabel = false,
  minDateFromLeave,
  maxDateFromLeave,
}: Props) => {
  const onChangeEvent = (value: DatePickerValue) => {
    if (!value.value?.from) return
    date.set(value.value?.from)
  }

  return (
    <F0DatePicker
      size="md"
      hideLabel={hideLabel}
      label={i18n.t('shift_management.no_selection_form.select_period')}
      onChange={(value) => {
        if (!value) return
        onChangeEvent(value)
      }}
      value={{
        granularity: 'day',
        value: {
          from: new Date(date.value),
          to: new Date(date.value),
        },
      }}
      minDate={minDateFromLeave?.toDate() || minDate.toDate()}
      maxDate={maxDateFromLeave?.toDate() || maxDate.toDate()}
    />
  )
}

export default SingleDatePicker
